import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',

  '.title': {
    fontWeight: 'bold',
    marginTop: '1rem'
  }
}))

export const InputCont = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',

  '.fileInput': {
    width: '100%'
  }
}))
export const InputCont1 = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',

  '.fileInput': {
    width: '49.5%'
  }
}))

export const DPContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})
export const BottomActionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: '10px 0px',

  button: {
    width: '100%',
    marginBottom: '10px !important',
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    button: {
      width: 'auto',
      marginBottom: '0px',
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    button: {
      width: 'auto',
      marginBottom: '0px',
    },
  },
})

export const FileCont = styled.div((props) => ({
  display: 'flex',
  marginTop: '0.5rem',

  '>div:first-child': {
    flex: 1
  },
  '>div:last-child': {
    flex: 4
  },

  '.titleFile': {
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  '.fileItem': {
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
    'button': {
      marginTop: '0.1rem'
    }
  },

  '.fileName': {
    display: 'flex',
    justifyContent: 'flex-start',
    wordBreak: 'break-all',
  },

  '.noFile': {
    fontStyle: 'italic',
    marginLeft: '1rem'
  },

  '.button': {
    marginLeft: '1rem'
  }
}))